// Rodapé da página /planos — reaproveita o componente FaleConosco da landing principal
// para manter consistência visual (logo, colunas de links, contato, copyright)
import React from "react";
import FaleConosco from "components/Landpage/FaleConosco";

export default function OnRodape() {
    return <FaleConosco />;
}
